import { ARCHIVE_TASK_FAIL, ARCHIVE_TASK_PENDING, ARCHIVE_TASK_SUCCESS } from "../../actions/types";

const initialState = { 
    archiveTask: [],
    isArchiveTaskLoading: false,
    };

const archive_task_reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ARCHIVE_TASK_SUCCESS:
            return {
                ...state,
                archiveTask: payload.archiveTask,
                isArchiveTaskLoading: false,
            };
        case ARCHIVE_TASK_PENDING:
            return {
                ...state,
                archiveTask: payload.archiveTask,
                isArchiveTaskLoading: true,
            };
        case ARCHIVE_TASK_FAIL:
            return {
                ...state,
                archiveTask: [],
                isArchiveTaskLoading: false,
            };
        default:
            return state;
    }
}
export default archive_task_reducer